import { navigate } from '@reach/router';
import IconChecklist from 'assets/svg/icons/checklist.inline.svg';
import IconCost from 'assets/svg/icons/cost.inline.svg';
import IconFile from 'assets/svg/icons/file.inline.svg';
import IconGDP from 'assets/svg/icons/gdp.inline.svg';
import IconProducts from 'assets/svg/icons/gdp.inline.svg';
import IconHome from 'assets/svg/icons/home.inline.svg';
import IconMenu from 'assets/svg/icons/menu.inline.svg';
import IconAcademy from 'assets/svg/icons/mortarboard.inline.svg';
import IconMultimedia from 'assets/svg/icons/multimedia.inline.svg';
import IconPhone from 'assets/svg/icons/phone.inline.svg';
import clsx from 'clsx';
import Button from 'components/Molecules/Button';
import { NAV } from 'constants/enums';
import { routes } from 'constants/routes';
import React from 'react';
import tw, { css, styled } from 'twin.macro';

import { DIRECTION } from '../../../AppMobile';

// TODO: better animation
const AnimatedTopContainer = styled.div`
	${tw`w-3/5 max-w-200 fixed border-l border-r border-solid border-grey-D z-nav bg-light`};
  transition: transform var(--animation-duration) ease-out;
  
	${tw`top-0 mt-nav border-b origin-top-right`};
		
	transform: ${({ isAnimate }) => isAnimate ?
		css`translate3d(0vw,0,0) scale(1); right: 0;` :
		css`translate3d(70vw,0,0) scale(0); right: 0;`};
`;

const AnimatedBottomContainer = styled.div`
	${tw`w-3/5 fixed border-l border-r border-solid border-grey-D z-nav bg-light`};
  transition: transform var(--animation-duration) ease-out;
  
	${tw`bottom-0 mb-nav border-t origin-bottom-right`};
		
	transform: ${({ isAnimate }) => isAnimate ?
		css`translate3d(0vw,0,0) scale(1); left: 0;` :
		css`translate3d(-70vw,0,0) scale(0); left: 0;`};
`;

function MainMenu({ isOpen, isOpenFromHeader, direction, onRedirect }) {
	const handleRedirect = route => () => {
		navigate(route);
		onRedirect(route);
	};

	// TODO: refactor
	if(direction === DIRECTION.TOP) {
		return (
			<AnimatedTopContainer direction={direction} isOpenFromHeader={isOpenFromHeader} isAnimate={isOpen}>
				<Button plate onClick={handleRedirect(routes.HOME)} tw='pt-10'>
					<IconHome width='1.5rem' height='1.5rem' />
					<p className='text-11 pl-12'>Home</p>
				</Button>
				<Button plate onClick={handleRedirect(routes.ACADEMY)}>
					<IconAcademy width='1.8rem' height='1.8rem' />
					<p className='text-11 pl-10'>Akademia</p>
				</Button>
				<Button plate onClick={handleRedirect(routes.PRODUCTS)}>
					<IconGDP width='1.5rem' height='1.5rem' />
					<p className='text-11 pl-12'>Produkty</p>
				</Button>
				<Button plate onClick={handleRedirect(routes.OFFERS)}>
					<IconCost width='1.5rem' height='1.5rem' />
					<p className='text-11 pl-12'>Moje oferty</p>
				</Button>
				<Button plate onClick={handleRedirect(routes.CONCLUSIONS)}>
					<IconFile width='1.5rem' height='1.5rem' />
					<p className='text-11 pl-12'>Moje wnioski</p>
				</Button>
				<Button plate onClick={handleRedirect(routes.SHAREHOLDING)}>
					<IconMultimedia width='1.5rem' height='1.5rem' />
					<p className='text-11 pl-12'>Akcjonariusze</p>
				</Button>
				<Button plate onClick={handleRedirect(routes.REGULATIONS)} tw='pb-10'>
					<IconChecklist width='1.5rem' height='1.5rem' />
					<p className='text-11 pl-12'>Regulaminy</p>
				</Button>
			</AnimatedTopContainer>
		);
	} else {
		return (
			<AnimatedBottomContainer direction={direction} isOpenFromHeader={isOpenFromHeader} isAnimate={isOpen}>
				<Button plate onClick={handleRedirect(routes.HOME)} tw='pt-10'>
					<IconHome width='1.5rem' height='1.5rem' />
					<p className='text-11 pl-12'>Home</p>
				</Button>
				<Button plate onClick={handleRedirect(routes.ACADEMY)}>
					<IconAcademy width='1.8rem' height='1.8rem' />
					<p className='text-11 pl-10'>Akademia</p>
				</Button>
				<Button plate onClick={handleRedirect(routes.PRODUCTS)}>
					<IconGDP width='1.5rem' height='1.5rem' />
					<p className='text-11 pl-12'>Produkty</p>
				</Button>
				<Button plate onClick={handleRedirect(routes.OFFERS)}>
					<IconCost width='1.5rem' height='1.5rem' />
					<p className='text-11 pl-12'>Moje oferty</p>
				</Button>
				<Button plate onClick={handleRedirect(routes.CONCLUSIONS)}>
					<IconFile width='1.5rem' height='1.5rem' />
					<p className='text-11 pl-12'>Moje wnioski</p>
				</Button>
				<Button plate onClick={handleRedirect(routes.SHAREHOLDING)}>
					<IconMultimedia width='1.5rem' height='1.5rem' />
					<p className='text-11 pl-12'>Akcjonariusze</p>
				</Button>
				<Button plate onClick={handleRedirect(routes.REGULATIONS)} tw='pb-10'>
					<IconChecklist width='1.5rem' height='1.5rem' />
					<p className='text-11 pl-12'>Regulaminy</p>
				</Button>
			</AnimatedBottomContainer>
		);
	}
}

const Item = ({ Icon, name, isActive, width, height, ...props }) => (
	<Button tw='h-full px-10 rounded-0' {...props}>
		<div className={clsx('content-bottom', isActive && 'content-bottom-animate', 'flex flex-col items-center justify-center')}>
			<Icon className={clsx('mb-03', isActive && 'fill-current text-main')} width={width} height={height} />
			<p className={clsx('text-08', isActive && 'text-main')}>{name}</p>
		</div>
	</Button>
);

const cssBottomNavigation = css`
	${tw`z-nav bg-light w-full h-nav flex items-center justify-between border border-solid border-grey-D fixed bottom-0`};
  .content-bottom:after {
    position: absolute;
    content: "";
    width: 0%;
    bottom: 0;
    height: 2px;
    background: var(--color-main);
    transition: width var(--animation-duration);
  }
  .content-bottom-animate:after {
    transition: width var(--animation-duration);
    width: 50%;
  }
`;

export default function BottomNavigation({ index, isOpenMenu, direction, isOpenFromHeader, onClickAcademy, onClickProducts, onClickMenu, onClickContact, onRedirectFromMenu }) {
	return (
		<div css={[ cssBottomNavigation ]}>
			<MainMenu isOpen={isOpenMenu} direction={direction} isOpenFromHeader={isOpenFromHeader} onRedirect={onRedirectFromMenu} />
			<Item height='1.4rem' width='1.4rem' onClick={onClickMenu} Icon={IconMenu} name='Menu' isActive={index === NAV.MENU} />
			<Item height='1.4rem' width='2rem' onClick={onClickAcademy} Icon={IconAcademy} name='Akademia' isActive={index === NAV.ACADEMY} />
			<Item height='1.4rem' width='1.5rem' onClick={onClickProducts} Icon={IconProducts} name='Produkty' isActive={index === NAV.PRODUCTS} />
			<Item height='1.4rem' width='1.4rem' onClick={onClickContact} Icon={IconPhone} name='Kontakt' isActive={index === NAV.CONTACT} />
		</div>
	);
}
